import defaultBanner from 'src/assets/images/templates/defaultBanner.jpeg';
import aboutBanner from 'src/assets/images/templates/aboutBanner.jpeg';

export const bannerImage = (data) => {
  return data?.bannerURL ||  defaultBanner ||  (data?.photos && data?.photos[0]?.path);
};

export const aboutImage = (data) => {
  return (
    data?.aboutImage || aboutBanner ||
    (data?.photos && (data?.photos[1]?.path || data?.photos[0]?.path))
  );
};

export const servicesImage = (data) => {
  return data?.bannerURL || defaultBanner ||  (data?.photos && data?.photos[0]?.path);
};

export const categoryImage = (categoryCover,data) => {
  return categoryCover ? categoryCover : data?.bannerURL || defaultBanner ||  (data?.photos && data?.photos[0]?.path);
};

export const contactImage = (data) => {
  return data?.bannerURL || defaultBanner || (data?.photos && data?.photos[0]?.path);
};

export const serviceDetailsImage = (service, photos) => {
  return service?.cover || (photos && photos[0]);
};

export const serviceDetailsImageMB = (service, photos, videos) => {
  let _photos = photos?.length ? photos.map(v=> ({path: v.photoPath,image:true})) : [];
  let _videos = videos?.length ? videos.map(v=> ({path: v,video:true})) : [];
  if(_photos?.length) {
    _photos.unshift({path: service?.cover, image:true});
  }
  else{
   _photos.push({path:service?.cover,image:true});
  };
  
  return _photos?.concat(_videos);
};
